import React from 'react';
import getIconSize from '../../../button/private/utils/buttonSizes/getIconSize';
import getLoaderSize from '../../../button/private/utils/buttonSizes/getLoaderSize';
import getLoaderColor from '../../../button/private/utils/buttonStyles/getLoaderColor';
import Loader from '../../../loader/Loader';
import GenericCheckAlternative from '../../../private/icons/GenericCheckAlternative';
const AnimationContent = ({ children, icon, animation, size, variant, }) => (React.createElement("span", { className: "block relative h-full pointer-events-none" },
    React.createElement("span", { className: "flex absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 content-center justify-center" },
        animation === 'progress' && (React.createElement(Loader, { color: getLoaderColor(variant), size: getLoaderSize(size) })),
        animation === 'success' && (React.createElement(GenericCheckAlternative, { "aria-label": "Success", className: getIconSize(size) }))),
    React.createElement("span", { className: "block opacity-0" },
        icon,
        children)));
export default AnimationContent;
